export const visuallyhidden = {
    position: 'absolute',
    height: 1,
    width: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    clip: 'rect(1px, 1px, 1px, 1px)',
} as const;
